import { CustomerDetails } from '../entities/requisition-model';
import { BasePluginData } from './base-plugin-data';

export class AdditionalInformationData extends BasePluginData {
  override get pluginStepName(): string { return 'AdditionalInformationData'; }

/**
   * Any special requirements.
   *
   *  */
  specialRequirements: string = '';

  /** Final comments on the request. */
  finalComments: string = '';



}
